// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"551":"e65bf35d","593":"ba21d4e8","828":"5ac8cfec"}[chunkId] + ".chunk.js";
};